import React, {Component} from 'react';
import {createFragmentContainer, graphql} from 'react-relay';
import ReactHighcharts from 'react-highcharts';
import {injectIntl} from 'react-intl';
import {grey500} from 'material-ui/styles/colors';
import moment from 'moment';

function getCollapseTimePeriodFunction(timePeriod) {
  return (arr, {date, npsDistribution, count}) => {
    const lastItemTimeMs = arr[arr.length-1] && arr[arr.length-1].date;
    const thisItemTimeMs = moment.utc(date).startOf(timePeriod).valueOf();
    if (lastItemTimeMs === thisItemTimeMs) {
      arr[arr.length-1].npsDistribution = {
        promoters: arr[arr.length-1].npsDistribution.promoters+npsDistribution.promoters,
        passives: arr[arr.length-1].npsDistribution.passives+npsDistribution.passives,
        detractors: arr[arr.length-1].npsDistribution.detractors+npsDistribution.detractors,
      };
      arr[arr.length-1].count += count;
      return arr;
    } else {
      return arr.concat([{
        date: moment.utc(date).startOf(timePeriod).valueOf(),
        npsDistribution: npsDistribution,
        count: count,
      }]);
    }
  };
}

function getNps({promoters, passives, detractors}) {
  const sum = promoters+passives+detractors;
  if (sum > 0) {
    return ((promoters/sum)-(detractors/sum))*100;
  } else {
    return null;
  }
}

function getData(npsByDate, intl) {
  if (!Array.isArray(npsByDate) || npsByDate.length <= 0) {
    return {
      data: [],
      tooltipDateFormatter: () => null,
      xAxisDateFormatter: () => null,
    };
  }

  const firstDate = npsByDate[0].date;
  const lastDate = npsByDate[npsByDate.length-1].date;
  const monthsCount = moment(lastDate).diff(moment(firstDate), 'months');

  if (monthsCount < 3) {
    return {
      data: npsByDate.map(({date, npsDistribution, count}) => {
        return {
          x: Date.parse(date),
          y: getNps(npsDistribution),
          count: count,
        };
      }),
      tooltipDateFormatter: ms => moment.utc(ms).format('dddd, D MMM Y'),
      xAxisDateFormatter: ms => moment.utc(ms).format('D MMM<br/>Y'),
    };
  } else if (monthsCount < 12) {
    return {
      data: npsByDate
        .reduce(getCollapseTimePeriodFunction('isoWeek'), [])
        .map(({date, npsDistribution, count}) => {
          return {
            x: date,
            y: getNps(npsDistribution),
            count: count,
          };
        }),
      tooltipDateFormatter: ms => {
        return intl.formatMessage({id: 'week'}) + moment.utc(ms).format(' W, Y');
      },
      xAxisDateFormatter: ms => {
        return intl.formatMessage({id: 'week'}) + moment.utc(ms).format(' W<br/>Y');
      },
    };
  } else {
    return {
      data: npsByDate
        .reduce(getCollapseTimePeriodFunction('month'), [])
        .map(({date, npsDistribution, count}) => {
          return {
            x: date,
            y: getNps(npsDistribution),
            count: count,
          };
        }),
      tooltipDateFormatter: ms => moment.utc(ms).format('MMMM Y'),
      xAxisDateFormatter: ms => moment.utc(ms).format('MMM<br/>Y'),
    };
  }
}

const styles = {
  wrapper: {
    padding: 15
  },
};

class NpsLineChart extends Component {
  render() {
    const intl = this.props.intl;

    const {
      data,
      tooltipDateFormatter,
      xAxisDateFormatter,
    } = getData(this.props.answersReport.npsByDate, intl);

    const chartConfig = {
      chart: {
        height: this.props.height-(styles.wrapper.padding*2),
        width: this.props.width-(styles.wrapper.padding*2),
      },
      title: null,
      legend: {
        enabled: false,
      },
      tooltip: {
        formatter: function() {
          const nps = ReactHighcharts.Highcharts.numberFormat(this.y, 0);
          const countMessage = intl.formatMessage({id: 'numberOfAnswers'}, {count: this.point.count});
          const date = tooltipDateFormatter(this.x);
          return `
            <b>NPS: ${nps}</b>
            <br/>
            ${countMessage} 
            <br/>
            ${date}
          `;
        },
      },
      xAxis: {
        type: 'datetime',
        labels: {
          formatter: function() {
            return xAxisDateFormatter(this.value);
          },
          style: {
            color: grey500,
          },
        },
      },
      yAxis: {
        title: {
          text: 'NPS',
          style: {
            color: grey500,
          },
        },
        min: this.props.staticYAxisScale ? -100 : null,
        max: this.props.staticYAxisScale ? 100: null,
        tickInterval: this.props.staticYAxisScale ? 50 : null,
      },
      plotOptions: {
        line: {
          dataLabels: {
            enabled: true,
            format: '{y:.0f}',
          },
        },
      },
      series: [{
        data,
      }],
    };

    return (
      <div style={styles.wrapper}>
        <ReactHighcharts
          config={chartConfig}
          domProps={{id: this.props.uniqueId}}
        />
      </div>
    );
  }
}

export default createFragmentContainer(
  injectIntl(NpsLineChart),
  graphql`
    fragment NpsLineChart_answersReport on AnswersReport {
      npsByDate {
        date
        count
        npsDistribution {
          promoters
          passives
          detractors
        }
      }
    }
  `,
);



// WEBPACK FOOTER //
// ./src/components/NpsLineChart/NpsLineChart.js